import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { ImpactStoriesProvider as Provider } from '@shapeable/ui';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const IMPACT_STORIES_QUERY = graphql`
query NodeAllImpactStoriesQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "ImpactStories" } }) {
    nodes {
      data
    }
  }
}
`;

export const ImpactStoriesProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(IMPACT_STORIES_QUERY), 'items')}>{children}</Provider>;
};
